/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-20 16:06:48
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\warehousingOrder\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询入库订单列表
export function getWareHousingOrder(params) {
  return request({
    url: '/wms/stockIn/list',
    method: 'get',
    params
  })
}

// 新增入库订单
export function addWarehousingOrder(data) {
  return request({
    url: '/wms/stockIn',
    method: 'post',
    data
  })
}

// 更新入库订单
export function updateWarehousingOrder(data) {
  return request({
    url: '/wms/stockIn',
    method: 'put',
    data
  })
}

// 删除入库订单
export function closeWarehousingOrder(data) {
  return request({
    url: `/wms/stockIn/close`,
    method: 'post',
    data
  })
}

//

export function getWarehousingOrderInfo(id) {
  return request({
    url: `/wms/stockIn/${id}`,
    method: 'get',
  })
}

// 查询可入库产品
export function getWareHousingProduct(params) {
  return request({
    url: '/wms/stockIn/listProduct',
    method: 'get',
    params
  })
}
// 处理作废udi码
export function handleInvalidUdiCode({ ids, minusBatch, reason }) {
  return request({
    // url: '/wms/stockIn/handleInvalidUdiCode',
    url: `/wms/inOutDetailCode/cancel/${ids}`,
    method: 'post',
    params: {
      minusBatch,
      reason
    }
  })
}
export function handleInvalidUdiCode2({ ids, minusBatch, reason, busiType}) {
  return request({
    url: `/wms/stockDetail/cancel/${ids}`,
    method: 'post',
    params: {
      minusBatch,
      reason,
      busiType
    }
  })
}


// 查询入库单产品已入库的UDI码
export function getInStockUdiCode(data) {
  return request({
    url: '/wms/stockIn/getInStockUdiCode',
    method: 'post',
    data
  })
}
// 查询关联关系
export function getRelationList(id) {
  return request({
    url: `/system/productionProduct/packQuery/${id}?type=SAAS`,
    method: 'get'
  })
}
// 分页查询入库码
export function getStockInCodeList(params) {
  return request({
    url: `/wms/stockInProductInst/list`,
    method: 'get',
    params
  })
}
// 移除入库实例
export function removeStockInCodeList(ids) {
  return request({
    url: `/wms/stockInProductInst/remove/${ids.join()}`,
    method: 'post',
  })
}

// 审核入库订单
export function auditWarehousingOrder(data) {
  return request({
    url: '/wms/stockIn/audit',
    method: 'post',
    data
  })
}
// 查询码包装内层信息
export function getCodePackInfo(udiCode) {
  return request({
    url: `/wms/inOutDetailCode/getCodePackInfo/${udiCode}`,
    method: 'get',
  })
}
// 取消生产入库
export function productionCancel(id) {
  return request({
    url: `/wms/stockIn/productionCancel`,
    method: 'get',
    params: {id}
  })
}
